module.exports = __webpack_public_path__ + "media/images/ui/arrow-down-5a34a008165b801be11a3b8afd60366c.png";